import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ORGANISATIONS_QUERY_KEY } from 'constants/queryKeys';
import OrganisationsService from 'services/OrganisationsService';
import { IUpdateOrganisationRequest } from 'interfaces/IOrganisations';

export const useUpdateOrganisation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: IUpdateOrganisationRequest) =>
      OrganisationsService.UpdateOrganisation(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ORGANISATIONS_QUERY_KEY] });
    },
  });
};

export default useUpdateOrganisation;
